import { Navigate } from 'react-router-dom';
import { useApp } from '../context/AppContext';
import type { ReactNode } from 'react';

export function ProtectedRoute({
  children,
  requireAdmin = false,
  requireJudge = false,
}: {
  children: ReactNode;
  requireAdmin?: boolean;
  requireJudge?: boolean;
}) {
  const { currentUser, loading } = useApp();

  // Wait for session restoration before deciding to redirect
  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <div style={{ textAlign: 'center' }}>
          <div style={{ width: 32, height: 32, border: '3px solid rgba(36,84,245,0.2)', borderTopColor: '#2454f5', borderRadius: '50%', animation: 'spin 0.8s linear infinite', margin: '0 auto 12px' }} />
          <div style={{ color: 'var(--iam-muted)', fontSize: 14 }}>Loading IAMMUZIK…</div>
        </div>
      </div>
    );
  }

  if (!currentUser) {
    return <Navigate to="/" replace />;
  }

  if (requireAdmin && currentUser.role !== 'ADMIN') {
    return <Navigate to="/app" replace />;
  }

  if (requireJudge && currentUser.role !== 'JUDGE' && currentUser.role !== 'ADMIN') {
    return <Navigate to="/app" replace />;
  }

  return <>{children}</>;
}
